import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Cache } from 'aws-amplify';
import { Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import '../../css/login.css';
import t3Logo from '../../assets/finsi_logo.png';
import { Link } from 'react-router-dom';
import PasswordStrengthMeter from '../../components/settings/users/PasswordStrengthMeter';

import { getCurrentUser, handleResetPasswordFields, resetPassword } from '../../store/actions/users/usersActions';

class ResetPassword extends Component {

  constructor() {
    super();
    this.state = {
      new_password: '',
      errors: ''
    }
    this.onChangeConfirmPassword = this.onChangeConfirmPassword.bind(this);
  }

  onChangeConfirmPassword(e) {
    let errors = '';
    this.setState({ confirm_password: e.target.value });

    if(this.state.new_password !== e.target.value){
      errors = "Passwords don't match.";
    }
    else{
      errors = "";
    }

    this.setState({
      errors: errors
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.resetPassword(() => {
      this.props.history.push('/reset-password');
    });
  }

  render() {
    const new_password = this.state.new_password;
    const apiToken = Cache.getItem('apiToken');
    if (!apiToken) {
      let submitValue = 'Submit';
      let isResettingPassword = this.props.users.resettingPassword;
  
      if (isResettingPassword) {
        submitValue = <Spinner animation="border" size="sm" />
      }
      
      return (
        <React.Fragment>
          <Row id="reset-password-page">
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <img className="company-logo" src={t3Logo} alt="t3-logo" width="100%" height="auto" />
              <h5 id="reset-password-header-text">Reset Password</h5> 
              <Form onSubmit={this.handleSubmit}>
                <Form.Group controlId="email">
                  <Form.Label id="company-lbl">Company Email</Form.Label>
                  <Form.Control type="text" placeholder="Enter Company Email" onChange={this.props.handleResetPasswordFields} />
                </Form.Group>
                <Form.Group controlId="password">
                  <Form.Label id="password-lbl">New Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter New Password"
                    onChange={this.props.handleResetPasswordFields}
                    onKeyUp={ e => this.setState({ new_password: e.target.value }) }
                  />
                  <PasswordStrengthMeter new_password = { new_password } />
                </Form.Group>
                <Form.Group controlId="confirm-password">
                  <Form.Label id="comfirm-password-lbl">Confirm Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter Confirm Password"
                    onChange={ this.onChangeConfirmPassword.bind(this) }
                  />
                  <label className="password-match-error-label">{ this.state.errors }</label>
                </Form.Group>
                <Button variant="primary" id="t3-login-button" size="sm" block type="submit" disabled={ this.state.new_password !== this.state.confirm_password }>
                  {submitValue}
                </Button>
                <Link id="back-to-login" to="#" onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push('/');
                }}>
                  Back to Login
                </Link>
              </Form>
            </Col>
          </Row>
        </React.Fragment>
      )
    }
    else {
      return (
        <Spinner animation="border" size="sm" />
      )
    }
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    handleResetPasswordFields: (...args) => dispatch(handleResetPasswordFields(...args)),
    resetPassword: (...args) => dispatch(resetPassword(...args)),
    getCurrentUser: (...args) => dispatch(getCurrentUser(...args))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)
